import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { cedarCityUTConfig } from "./data";

export default function CedarCityUTPage() {
  return <CityPageTemplate config={cedarCityUTConfig} />;
}